import React from 'react';
import styled from 'styled-components';
import { fonts } from '../common/mixins.js';
import ReservationAlert from './ReservationAlert.jsx';
import PayOnline from './PayOnline.jsx';
import PayWithCash from './PayWithCash.jsx';

const Container = styled.div`
    background-color:white;
    width:100%;
    padding:16px;
    border-radius:8px;
    height:100%;
    display:flex;
    flex-direction:column;
    gap:16px;
    `;

const Title = styled.div`
    ${fonts.normalTextBold()};
    `;

const SmallTitle = styled.div`
    ${fonts.normalTextSmallBold()};
`;

const FlexContainer = styled.div`
    width:100%;
    display:flex;
    gap:16px;
      @media (max-width: 1000px) {
      flex-direction:column;
  }
    `;

const TitleWithAmount = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    @media (max-width:767px) {
        flex-direction: column;
        align-items: start;
        gap: 16px;
    }
`;

const Amount = styled.div`
    font-family: 'pf_highway_sans_pro_lightRg';
    border: 1px solid #FCB041;
    background: #FFF7EC;
    border-radius: 8px;
    color: #0D0C1C;
    font-size: 14px;
    padding: 8px 16px;
    @media (max-width:767px) {
        width: 100%;
        justify-content: space-between;
        display: flex;
        align-items: center;
        font-size: 14px;
    }
`;

const PaymentMethods = ({ payUntil, culture, payWithCashCode, dateLocation, eventName, reservationExpired, outstandingAmount,requestKey, totalTickets, totalProducts}) => {

    return (
        <Container id="pendingPaymentContainer">
             <TitleWithAmount>
             <Title>{orderdetails_resources.Payment}</Title>
                <Amount id="paymentAmount">{orderdetails_resources.OutstandingAmount}{' '}<span style={{fontWeight: 600,fontSize:16}}>{outstandingAmount}</span></Amount>
             </TitleWithAmount>
            <ReservationAlert expirationDate={payUntil} culture={culture} />
            {!reservationExpired &&
                <>
            <SmallTitle>{orderdetails_resources.PaymentMethods}</SmallTitle>         
                <FlexContainer>
                    <PayOnline requestKey={requestKey} />
                    <PayWithCash paymentCode={payWithCashCode} expirationDate={payUntil} culture={culture} dateLocation={dateLocation} eventName={eventName} totalTickets={totalTickets} totalProducts={totalProducts} outstandingAmount={outstandingAmount } />
                </FlexContainer></>}
        </Container>      
    );
};

export default PaymentMethods;